import {createAsyncThunk, current} from "@reduxjs/toolkit";
import {PEV} from "../../../common/utils";
import * as service from "./service";

export const getUserGroupsList = createAsyncThunk("userGroupList/get", async (userGroupTypeId) => {
  return await service.getUserGroupList(userGroupTypeId);
});

export const getUserGroupsListExtraReducers = {
  [getUserGroupsList.pending.type]: (state, action) => {
    const userGroupTypeId = action.meta.arg;
    state.userGroupList[userGroupTypeId] = PEV([], "Fetching user group list");
  },
  [getUserGroupsList.fulfilled.type]: (state, action) => {
    let userGroupList = { ...action.payload };
    userGroupList.userGroupList = userGroupList.userGroupList.map(userGroup => {
      const userGroupScope = current(state).userGroupScopeList.value.find(x => x.userGroupId === userGroup.id);
      const scope = userGroupScope?.scope ?? null
      return {
        ...userGroup,
        scope
      }
    })
    const userGroupTypeId = action.meta.arg;
    state.userGroupList[userGroupTypeId] = PEV(userGroupList);
  },
  [getUserGroupsList.rejected.type]: (state, action) => {
    const userGroupTypeId = action.meta.arg;
    state.userGroupList[userGroupTypeId] = PEV([], null, "Error while fetching user group list");
  },
};

export function userGroupListTabStateManagement(state, userGroupTypeId, activeTab) {
  if (!(userGroupTypeId in state.userGroupListTabStates)) {
    state.userGroupListTabStates[userGroupTypeId] = {};
  }
  state.userGroupListTabStates[userGroupTypeId] = {
    ...state.userGroupListTabStates[userGroupTypeId],
    activeTab,
  };
}

export const listUserGroupTabTypes = {
  AllList: "All ",
  MyList: "My ",
};

export const ListUserGroupTabNameQueryParam = "tabName";
